import { FileAttachment } from "../../../features/file-attachments/types/file-attachment.interface";
import * as http from "../../../services/http.service";
import { ICampaignBriefData } from "../types/campaign-brief-state/campaign-brief-state.interface";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SearchResults } from "../../../types/search/search-results.interface";

export function fetchAttachments(briefId: number): Observable<FileAttachment[]> {
  return http
    .get<SearchResults<FileAttachment>>(`/campaign-briefs/${briefId}/attachments/`)
    .pipe(map((searchResults) => searchResults.results));
}

export function addAttachment(briefId: string, file: File): Observable<FileAttachment> {
  const formData = new FormData();
  formData.append("attachment", file);
  return http.post(uploadEndPoint(briefId), formData);
}

export function deleteAttachment(
  brief: ICampaignBriefData,
  id: number
): Observable<FileAttachment[]> {
  if (isNaN(id) || id < 1) {
    throw new Error(`Invalid id [${id}]`);
  }
  return http
    .del(endPoint(id))
    .pipe(map(() => removeFileAttachedFromCampaignBriefs(brief.overviewAttachments, id)));
}

export const removeFileAttachedFromCampaignBriefs = (
  files: FileAttachment[],
  fileId: number
): FileAttachment[] => files.filter((item: FileAttachment) => item.id !== fileId);

function endPoint(id: number): string {
  return `/campaign-briefs/attachments/${id}/`;
}

function uploadEndPoint(briefId: string): string {
  return `/campaign-briefs/${briefId}/attachments/`;
}

export const addAttachedFile = (
  file: FileAttachment,
  attachedFiles: FileAttachment[]
): FileAttachment[] => attachedFiles.concat([file]);
